import { MutationOptions } from '@tanstack/react-query';
import { useApiMutation } from '~/hooks';
import {
  forgotPasswordApi,
  resendVerificationEmailApi,
  resetPasswordApi,
  signUpApi,
  verifyEmailApi,
} from '../repository';
import {
  ForgotPasswordData,
  ResendVerificationEmailData,
  ResetPasswordData,
  SignUpData,
  VerifyEmailData,
} from '~/types';

export const useSignUpMn = (
  options?: MutationOptions<SignUpData, CustomAxiosError, SignUpData>,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (data: SignUpData) => {
      return signUpApi(data);
    },
  });
};

export const useResetPasswordMn = (
  options?: MutationOptions<
    ResetPasswordData,
    CustomAxiosError,
    ResetPasswordData
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (data: ResetPasswordData) => {
      return resetPasswordApi(data);
    },
  });
};

export const useForgotPasswordMn = (
  options?: MutationOptions<
    ForgotPasswordData,
    CustomAxiosError,
    ForgotPasswordData
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (data: ForgotPasswordData) => {
      return forgotPasswordApi(data);
    },
  });
};

export const useVerifyEmailMn = (
  options?: MutationOptions<VerifyEmailData, CustomAxiosError, VerifyEmailData>,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (data: VerifyEmailData) => {
      return verifyEmailApi(data);
    },
  });
};

export const useResendVerificationEmailMn = (
  options?: MutationOptions<
    ResendVerificationEmailData,
    CustomAxiosError,
    ResendVerificationEmailData
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (data: ResendVerificationEmailData) => {
      return resendVerificationEmailApi(data);
    },
  });
};
